import Clipboard from "v-clipboard";
import Vue from "vue";

Vue.use(Clipboard);
